export default __webpack_public_path__ + "static/media/kyselyt.ef056cd4.svg";